import React from 'react';
import Grid from '@material-ui/core/Grid';
import withWidth, { isWidthUp, WithWidthProps } from '@material-ui/core/withWidth';

import { useTranslation } from 'hooks/useTranslation';
import { LinearChart } from 'features/dashboard/components/LinearChart';
import { useSelector } from 'store';

import { useStyles } from './styles';

export const InfoCharts = withWidth()(({ width }: WithWidthProps) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const ordersGraphState = useSelector(state => state.dashboard.ordersGraph);
  const redemptionsGraph = useSelector(state => state.dashboard.redemptionsGraph);

  return (
    <Grid
      container
      justifyContent="space-between"
      wrap={width && isWidthUp('md', width) ? 'nowrap' : undefined}
      className={classes.root}
    >
      <LinearChart
        title={t('orders')}
        reducerType="ordersGraph"
        state={ordersGraphState}
        xs={width && isWidthUp('md', width) ? 6 : 12}
        color="#1921FA"
      />
      <LinearChart
        color="#00B2AE"
        title={t('redemptions')}
        reducerType="redemptionsGraph"
        state={redemptionsGraph}
        xs={width && isWidthUp('md', width) ? 6 : 12}
      />
    </Grid>
  );
});
